import { render, staticRenderFns } from "./SubmitView.vue?vue&type=template&id=11149bbd"
import script from "./SubmitView.vue?vue&type=script&lang=js"
export * from "./SubmitView.vue?vue&type=script&lang=js"
import style0 from "./SubmitView.vue?vue&type=style&index=0&id=11149bbd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports